import { makeStyles } from "@material-ui/core";

import type { CoretexTheme } from "../../theme";

const useStyles = makeStyles((theme: CoretexTheme) => ({
  root: {
    padding: 0,
    width: "50px",
    height: "24px",
    marginRight: theme.spacing(6),
  },
  thumb: {
    width: "21px",
    height: "22px",
    boxShadow: "1px 1px 2px rgba(0, 0, 0, 0.1)",
  },
  track: {
    opacity: 1,
    backgroundColor: theme.palette.mono.gray,
    width: "48px",
    height: "22px",
    borderRadius: "100px",
  },
  switchBase: {
    "&$checked": {
      color: theme.palette.mono.white,
      background: "none",
      transform: "translateX(27px)",
    },
    "&:hover, &$checked:hover": {
      background: "none",
    },
    "&$checked + $track": {
      backgroundColor: theme.palette.colour.primaryBlue,
      opacity: 1,
    },
    padding: 0,
  },
  checked: {},
  focusVisible: {},
}));

export default useStyles;
